/**
 * Maison Cart — micro-interacción de eliminación (Fase 14E).
 *
 * Por qué existe: Dawn reemplaza el innerHTML de #main-cart-items
 * completo cuando el fetch de CartItems.updateQuantity() resuelve (ver
 * assets/cart.js, CartRemoveButton/CartItems) — la fila <tr> que el
 * usuario acaba de tocar desaparece de golpe en cuanto llega la
 * respuesta, sin transición. Este archivo NO sustituye ni retrasa ese
 * fetch: solo agrega una clase visual (.cart-item--removing, estilada
 * en assets/maison-cart.css) en el mismo click, en fase de captura,
 * ANTES de que el listener nativo de <cart-remove-button> (definido en
 * cart.js) dispare su propio preventDefault + updateQuantity. Ambos
 * listeners coexisten sin conflicto: este nunca llama preventDefault
 * ni detiene la propagación, así que el comportamiento real de
 * eliminación (Ajax, contador, totales) sigue intacto tal cual Dawn lo
 * define.
 *
 * Respeta prefers-reduced-motion: motion-reduce/CSS
 * ya neutraliza la transición en maison-cart.css, así que aquí basta
 * con seguir agregando la clase sin lógica de timing propia — no hay
 * temporizador que cancelar ni estado que limpiar (el nodo se destruye
 * junto con el resto de la fila cuando Dawn reemplaza el HTML).
 */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('cart-remove-button a, cart-remove-button');
      if (!trigger) return;

      var row = trigger.closest('.cart-item');
      if (!row) return;

      row.classList.add('cart-item--removing');
    },
    true
  );
})();
